import { IPPVisionObjective } from '../types';
import { EntityService } from './EntityService';

export class PPVisionObjectiveService extends EntityService<IPPVisionObjective> {
    constructor() {
        super(`/PPVisionObjectives`);
    }

}